import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import api from "../../libs/axios";

const CARD_DEFS: { key: string; label: string; color: string; icon: string }[] = [
  { key: "total_sites", label: "Total Sites", color: "bg-slate-50 border-slate-200 text-slate-700", icon: "📍" },
  { key: "planned", label: "Planned", color: "bg-indigo-50 border-indigo-200 text-indigo-700", icon: "📋" },
  { key: "material_pending", label: "Material Pending", color: "bg-amber-50 border-amber-200 text-amber-700", icon: "📦" },
  { key: "in_progress", label: "In Progress", color: "bg-sky-50 border-sky-200 text-sky-700", icon: "⚙️" },
  { key: "completed", label: "Completed", color: "bg-green-50 border-green-200 text-green-700", icon: "✅" },
  { key: "pending_mb", label: "Pending MB", color: "bg-yellow-50 border-yellow-200 text-yellow-700", icon: "📄" },
  { key: "pending_boq", label: "Pending BOQ", color: "bg-orange-50 border-orange-200 text-orange-700", icon: "💰" },
  { key: "pending_billing", label: "Pending Billing", color: "bg-purple-50 border-purple-200 text-purple-700", icon: "💳" },
  { key: "closed", label: "Billing Done", color: "bg-gray-50 border-gray-200 text-gray-700", icon: "🔒" },
  { key: "cancelled", label: "Cancelled", color: "bg-red-50 border-red-200 text-red-700", icon: "❌" },
];

const IncDashboard: React.FC = () => {
  const [cards, setCards] = useState<Record<string, number>>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await api.get("/inc/dashboard");
        setCards(res.data?.data?.cards || {});
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="p-4 md:p-6 max-w-7xl mx-auto">
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900">INC Dashboard</h1>
        <p className="text-gray-600 mt-2">Installation & Commissioning overview and progress tracking</p>
      </div>

      {/* Action Bar */}
      <div className="mb-8 flex gap-3 flex-wrap">
        <Link
          to="/inc/sites"
          className="inline-flex items-center gap-2 px-4 py-2 bg-blue-800 hover:bg-blue-900 text-white rounded-md text-sm font-medium transition-colors"
        >
          View All Sites <FaArrowRight className="w-3 h-3" />
        </Link>
        <Link
          to="/inc/dashboard"
          className="inline-flex items-center gap-2 px-4 py-2 bg-white border border-gray-300 hover:bg-gray-50 text-gray-700 rounded-md text-sm font-medium transition-colors"
        >
          Refresh
        </Link>
      </div>

      {/* Cards Grid */}
      {loading ? (
        <div className="flex items-center justify-center py-16">
          <div className="text-center">
            <div className="w-8 h-8 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin mx-auto mb-2"></div>
            <p className="text-gray-500 text-sm">Loading dashboard...</p>
          </div>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {CARD_DEFS.map((c) => (
            <div
              key={c.key}
              className={`border rounded-lg p-5 ${c.color} transition-all hover:shadow-md hover:-translate-y-0.5`}
            >
              <div className="flex items-center justify-between mb-2">
                <span className="text-2xl">{c.icon}</span>
                <span className="text-3xl font-bold text-gray-900">{cards[c.key] ?? 0}</span>
              </div>
              <div className="text-sm font-medium text-gray-700">{c.label}</div>
            </div>
          ))}
        </div>
      )}

      {/* Footer */}
      <div className="mt-12 text-center text-sm text-gray-500">
        <p>Last updated: {new Date().toLocaleTimeString()}</p>
      </div>
    </div>
  );
};

export default IncDashboard;
